<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="case_detail_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><a href="/servicecaselist" style="color: rgba(19,20,28,0.6);font-weight: 500;">案例库</a></el-breadcrumb-item>
          <el-breadcrumb-item><a style="color: rgba(19,20,28,0.9);font-weight: 700;">案例详情页</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="service_case_detail">
        <div class="service_case_detail_title">
          <div class="service_case_detail_title_left">
            <span class="service_case_detail_title_text">{{ caseDetail.name }}</span>
            <span class="case_card_list_item_status" style="position: inherit" :class="'case_card_list_item_status_' + caseDetail.review_status">{{ status_dic[caseDetail.review_status] }}</span>
          </div>
          <div class="service_case_detail_title_right">
            <el-button style="height:32px;padding: 8px 12px;margin-left: 3px;" @click="editCase(caseDetail.case_id)"><i
                class="el-icon-edit-outline"></i>编辑</el-button>
            <el-button @click="visible = true" style="height:32px;padding: 8px 12px;margin-left: 3px;"><i
                class="el-icon-delete"></i>删除</el-button>
          </div>
        </div>
        <div class="service_case_detail_content" v-if="caseDetail.review_status == 3">
          <div class="service_case_detail_content_label">未通过原因：</div>
          <div class="service_case_detail_content_text">
            {{ caseDetail.review_content }}
          </div>
        </div>
        <div class="service_case_detail_info">
          <div class="service_case_detail_info_row">
            <div class="service_case_detail_info_item">
              <span class="service_case_detail_info_item_label">项目周期：</span>
              <span class="service_case_detail_info_item_value">{{ caseDetail.cycle }}</span>
            </div>
            <div class="service_case_detail_info_item">
              <span class="service_case_detail_info_item_label">项目金额：</span>
              <span style="width: 120px;" class="service_case_detail_info_item_value">{{ xy_case_money_dict[caseDetail.money] }}</span>
            </div>
            <div class="service_case_detail_info_item">
              <span class="service_case_detail_info_item_label">客户品牌：</span>
              <span style="width: 120px;" class="service_case_detail_info_item_value">{{ caseDetail.brand_name }}</span>
            </div>
            <div class="service_case_detail_info_item">
              <span class="service_case_detail_info_item_label">所属行业：</span>
              <span class="service_case_detail_info_item_value">{{ caseDetail.industry_top_name }}</span>
            </div>
          </div>
          <div class="service_case_detail_info_row">
            <div class="service_case_detail_info_item">
              <span class="service_case_detail_info_item_label">所属创意类目：</span>
              <span class="service_case_detail_info_item_value">
                {{caseDetail.category_second_name}}
              </span>
            </div>
          </div>
        </div>
        <div class="service_case_detail_content">
          <div class="service_case_detail_content_label">服务内容：</div>
          <div class="service_case_detail_content_text" v-html="caseDetail.service_content">
          </div>
        </div>
        <div class="service_case_detail_content">
          <div class="service_case_detail_content_label">封面图：</div>
          <div class="service_case_detail_content_cover">
            <el-image :src="item.url" class="service_case_detail_content_cover_img" :preview-src-list="caseCoverPreview" v-for="(item, key) in caseCover" :key="key">
            </el-image>
          </div>
        </div>
        <div class="service_case_detail_content">
          <div class="service_case_detail_content_label">图片/视频：</div>
          <div class="service_case_detail_content_imgs">
            <template v-for="(item, key) in caseFiles">
              <video v-if="item.suffix == 'mp4'" class="service_case_detail_content_imgs_video" :key="key" :controls="true" :src="item.url"></video>
              <el-image v-else :src="item.url" class="service_case_detail_content_imgs_img"  :key="key" :preview-src-list="srcList"></el-image>
            </template>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
        :visible.sync="visible"
        width="360px"
        class="service_case_detail_modal"
    >
      <div class="service_case_detail_modal_title" slot="title"><img :src="require('@/assets/img/icon_hint.png')" />确定要删除这个案例吗？</div>
      <span class="service_case_detail_modal_text">案例将被完全删除，无法找回，您可以重新提交并审核</span>
      <span slot="footer" class="dialog-footer">
        <el-button style="padding: 9px 38px;" @click="visible = false">取 消</el-button>
        <el-button style="padding: 9px 38px;" type="primary" @click="delCase(caseDetail.case_id)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// eslint-disable-next-line
import * as commfun from '@/common/common.js'
import Cookies from 'js-cookie'
var pubPrefix = '/api'
export default {
  name: 'ServiceCaseDetail',
  components: {
    Mainl
  },
  data: function () {
    return {
      srcList: [],
      visible: false,
      caseDetail: {},
      caseCover: [],
      caseCoverPreview: [],
      caseFiles: [],
      xy_case_money_dict: [], // 项目金额字典
      industry_dic: [], // 所属行业字典
      category_dic: [], // 创意类目字典
      top_creative_categories_dict: [], // 单一级创意类目字典
      status_dic: {1: '待审核', 2: '已通过', 3: '未通过'}
    }
  },
  created () {
    // 获取字典数据
    this.getDict()
  },
  mounted () {
    this.initDetail()
  },
  methods: {
    // 获取字典
    getDict () {
      var selfthis = this
      var url = pubPrefix + '/api/case/dict'
      commfun.ajaxGet(selfthis, url, {}, function (selfthis, result) {
        selfthis.xy_case_money_dict = result.xy_case_money_dict
        selfthis.industry_dic = result.industry_dic
        selfthis.category_dic = result.category_dic
        selfthis.top_creative_categories_dict = result.top_creative_categories_dict
      }, function (selfthis, result) {
        selfthis.$message({
          showClose: true,
          message: '字典查询错误，请联系管理员！',
          type: 'warning',
          customClass: 'zZindex'
        })
      })
    },
    // 列表数据
    initDetail: function () {
      var selfthis = this
      var url = pubPrefix + '/api/case/caseDetail'
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var case_id = urlParams.get('case_id');
      var postdata={
        case_id: case_id
      }
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (data == null || data === undefined) {
          selfthis.caseDetail = {}
          selfthis.caseCover = []
          selfthis.caseFiles = []
        } else {
          selfthis.caseDetail = data.case_detail
          selfthis.caseCover = data.case_cover
          if (selfthis.caseCover.length > 0) {
            for (var i = 0; i < selfthis.caseCover.length; i ++) {
              selfthis.caseCoverPreview.push(selfthis.caseCover[i].url)
            }
          }
          selfthis.caseFiles = data.case_files
          if (selfthis.caseFiles.length > 0) {
            for (var i = 0; i < selfthis.caseFiles.length; i ++) {
              if (selfthis.caseFiles[i].suffix != 'mp4') {
                selfthis.srcList.push(selfthis.caseFiles[i].url)
              }
            }
          }
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 编辑案例
    editCase (case_id) {
      window.location.href = '/servicecaseadd?case_id=' + case_id  // 改为当前页面打开
      // window.open('/servicecaseadd?case_id=' + case_id)
    },
    // 删除案例
    delCase (case_id) {
      var selfthis = this
      if (case_id == undefined || case_id == null) {
        commfun.showMessage(selfthis, 'warning', '缺少参数，请联系管理员')
        return
      }
      var url = pubPrefix + '/api/case/delCase'
      commfun.ajaxPost(selfthis, url, {case_id}, function (selfthis, data) {
        selfthis.visible = false
        commfun.showMessage(selfthis, 'success', '已删除！')
        setTimeout(function () {
          location.href = '/servicecaselist'
        }, 1000);
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ServiceCaseDetail.vue